export const ExpandedComponent = ({data}) => <div className="p-3">{data.desc}</div>;
